
export const environment = {
	production: true,
	sandboxApiUrl: 'https://hosts-au.morgan-au.salestabcentral.com/',
	brand: 'L',
	testUsername: '',
	testPassword: '',
	addressable_api: {
		api_key: 'SR2xBZMHDc3t24ttX8ROCw',
		country_code: 'AU'
	},
	country: 'AU',
	allowItemsWithNoDelivery: false,
	allowUnlinkedOptions: true,
	allowEditableDescriptions: true,
	surchargeEnabled: false,
};
